/* ==========================================================================
   „Хартия и мастило“ – поведение
   Всичко е на custom elements, за да работи и при section rendering в
   theme editor-а (елементите се закачат сами, щом попаднат в DOM-а).
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------ Акордеони ---- */
  /* <details>-подобно поведение, но с пълен контрол върху „+“ индикатора. */

  class HmAccordion extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      var btn = event.target.closest('.accordion__btn');
      if (!btn || !this.contains(btn)) return;

      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;

      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.classList.toggle('is-open', !open);
    }
  }

  /* ------------------------------------------------- Hero „пишеща машина“ */
  /* Двойките (префикс + суфикс) идват от секцията като JSON.               */

  class HmTypewriter extends HTMLElement {
    connectedCallback() {
      this.prefixEl = this.querySelector('[data-prefix]');
      this.typedEl = this.querySelector('[data-typed]');

      try {
        this.pairs = JSON.parse(this.querySelector('[data-pairs]').textContent);
      } catch (e) {
        this.pairs = [];
      }
      if (!this.pairs.length || !this.prefixEl || !this.typedEl) return;

      // При prefers-reduced-motion показваме първата двойка статично.
      if (reduceMotion) {
        this.prefixEl.textContent = this.pairs[0].prefix;
        this.typedEl.textContent = this.pairs[0].suffix;
        return;
      }

      // Сървърът вече е отпечатал първата двойка цяла (важно е за no-JS и
      // за SEO). Затова тръгваме от „изписано докрай“, а не от нула – иначе
      // първият tick би отрязал текста до една буква и окото го хваща.
      this.index = 0;
      this.chars = this.pairs[0].suffix.length;
      this.deleting = false;
      this.prefixEl.textContent = this.pairs[0].prefix;

      // Не хабим кадри, докато hero-то е извън екрана.
      this.observer = new IntersectionObserver(
        function (entries) {
          this.visible = entries[0].isIntersecting;
          if (this.visible && !this.timer) this.tick();
        }.bind(this),
        { threshold: 0 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.timer = null;
      if (this.observer) this.observer.disconnect();
    }

    tick() {
      var pair = this.pairs[this.index];
      var suffix = pair.suffix;
      var delay;

      if (this.deleting) {
        this.chars -= 1;
        delay = 28;
        if (this.chars <= 0) {
          this.deleting = false;
          this.index = (this.index + 1) % this.pairs.length;
          this.prefixEl.textContent = this.pairs[this.index].prefix;
          delay = 600;
        }
      } else {
        this.chars += 1;
        delay = 65 + Math.random() * 55; // 65–120ms на буква
        if (this.chars >= suffix.length) {
          this.chars = suffix.length;
          this.deleting = true;
          delay = 2100;
        }
      }

      this.typedEl.textContent = suffix.slice(0, Math.max(this.chars, 0));

      if (!this.visible) {
        this.timer = null;
        return;
      }
      this.timer = setTimeout(this.tick.bind(this), delay);
    }
  }

  /* ------------------------------------------------ Брояч за количество - */
  /* Обновява и живата обща цена в CTA бутона.                              */

  class HmQuantity extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="quantity"]');
      if (!this.input) return;

      this.min = parseInt(this.input.min, 10) || 1;
      this.max = parseInt(this.input.max, 10) || 9;

      this.onClick = this.onClick.bind(this);
      this.onInput = this.onInput.bind(this);
      this.addEventListener('click', this.onClick);
      this.input.addEventListener('change', this.onInput);
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.input) this.input.removeEventListener('change', this.onInput);
    }

    onClick(event) {
      var btn = event.target.closest('[data-step]');
      if (!btn) return;
      this.setValue(this.value() + parseInt(btn.dataset.step, 10));
    }

    onInput() {
      this.setValue(this.value());
    }

    value() {
      var n = parseInt(this.input.value, 10);
      return isNaN(n) ? this.min : n;
    }

    setValue(n) {
      this.input.value = Math.min(this.max, Math.max(this.min, n));
      this.sync();
    }

    sync() {
      var qty = this.value();

      this.querySelectorAll('[data-step]').forEach(function (btn) {
        var next = qty + parseInt(btn.dataset.step, 10);
        btn.disabled = next < this.min || next > this.max;
      }, this);

      // Живата обща цена: unit price идва в най-малката парична единица.
      // Обновяваме всички екземпляри – CTA бутона и лепкавата лента.
      document.querySelectorAll('[data-total-price]').forEach(function (target) {
        var unit = parseInt(target.dataset.unitPrice, 10);
        if (isNaN(unit)) return;
        target.textContent = formatMoney(unit * qty, target.dataset.moneyFormat);
      });
    }
  }

  /* Форматира цента-стойност по формата на магазина (напр. „€{{amount}}“). */
  function formatMoney(cents, format) {
    var amount = cents / 100;
    var withComma = amount.toFixed(2);
    var parts = withComma.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    if (!format) return whole + ',' + parts[1];

    // Поддържаме двата варианта на Shopify: с и без десетични.
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, whole + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount\s*\}\}/g, whole + '.' + parts[1]);
  }

  /* ------------------------------------------------------- Варианти ----- */
  /* При смяна на варианта обновяваме цената, отстъпката и живата обща сума. */

  class HmVariants extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-variant-input]');
      if (!this.input || this.input.tagName !== 'SELECT') return;

      try {
        this.variants = JSON.parse(this.dataset.variants);
      } catch (e) {
        this.variants = [];
      }

      this.onChange = this.onChange.bind(this);
      this.input.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      if (this.input) this.input.removeEventListener('change', this.onChange);
    }

    onChange() {
      var id = parseInt(this.input.value, 10);
      var variant = this.variants.filter(function (v) { return v.id === id; })[0];
      if (!variant) return;

      var format = this.dataset.moneyFormat;
      var now = document.querySelector('[data-price-now]');
      var was = document.querySelector('[data-price-was]');
      var save = document.querySelector('[data-price-save]');
      var submit = this.closest('form') ? this.closest('form').querySelector('[type="submit"]') : null;

      if (now) now.textContent = formatMoney(variant.price, format);

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (was) {
        was.hidden = !onSale;
        if (onSale) was.textContent = formatMoney(variant.compare_at_price, format);
      }
      if (save) {
        save.hidden = !onSale;
        if (onSale) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          save.textContent = save.textContent.replace(/\d+/, pct);
        }
      }

      document.querySelectorAll('[data-total-price]').forEach(function (el) {
        el.dataset.unitPrice = variant.price;
      });
      // Пресмятането на сумата живее в hm-quantity – будим го със 'change'.
      var qtyInput = document.querySelector('hm-quantity input[name="quantity"]');
      if (qtyInput) qtyInput.dispatchEvent(new Event('change'));

      if (submit) {
        submit.disabled = !variant.available;
        if (!variant.available) submit.textContent = this.dataset.soldOut;
      }
    }
  }

  /* ------------------------------------------------------- Галерия ------ */

  class HmGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-gallery-main]');
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb || !this.main) return;

      event.preventDefault();
      this.main.src = thumb.dataset.full;
      this.main.srcset = thumb.dataset.fullSrcset || '';
      this.main.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';

      this.querySelectorAll('[data-gallery-thumb]').forEach(function (el) {
        el.setAttribute('aria-current', String(el === thumb));
      });
    }
  }

  /* ---------------------------------------------------- Мобилно меню ---- */

  class HmMenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-menu-toggle]');
      this.panel = this.querySelector('[data-menu-panel]');
      if (!this.toggle || !this.panel) return;

      this.onToggle = this.onToggle.bind(this);
      this.onKey = this.onKey.bind(this);
      this.toggle.addEventListener('click', this.onToggle);
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
      document.removeEventListener('keydown', this.onKey);
    }

    onToggle() {
      this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true');
    }

    onKey(event) {
      if (event.key === 'Escape') this.setOpen(false);
    }

    setOpen(open) {
      this.toggle.setAttribute('aria-expanded', String(open));
      this.panel.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
  }

  /* ------------------------------------------------ Мастилено разкриване */
  /* Децата с [data-reveal] се появяват стъпаловидно, щом контейнерът влезе
     в екрана. Без JS (или с reduced-motion) нищо не се крие – .is-armed се
     слага чак тук. */

  class HmReveal extends HTMLElement {
    connectedCallback() {
      if (reduceMotion || !('IntersectionObserver' in window)) return;

      this.querySelectorAll('[data-reveal]').forEach(function (el, i) {
        el.style.setProperty('--reveal-delay', i * 0.13 + 's');
      });
      this.classList.add('is-armed');

      this.observer = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          this.classList.add('is-inked');
          this.observer.disconnect();
        }.bind(this),
        { threshold: 0.25 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  /* ---------------------------------------------- Лепкава лента (PDP) --- */
  /* Показва се, щом наблюдаваният ред за покупка излезе НАГОРЕ от екрана. */

  class HmStickyBuy extends HTMLElement {
    connectedCallback() {
      this.target = document.querySelector(this.dataset.watch || '.pdp__buy');
      if (!this.target || !('IntersectionObserver' in window)) return;

      this.io = new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          this.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.bottom < 0);
        }.bind(this),
        { threshold: 0 }
      );
      this.io.observe(this.target);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  /* ------------------------------------------------ Броящи се числа ----- */
  /* „15 000+“ се брои от нула нагоре, щом влезе в екрана. Сървърът рендира
     крайната стойност – без JS или с reduced-motion тя просто си стои. */

  class HmCount extends HTMLElement {
    connectedCallback() {
      var m = this.textContent.trim().match(/^([\d\s ]+)(.*)$/);
      if (!m) return;

      this.target = parseInt(m[1].replace(/[\s ]/g, ''), 10);
      this.suffix = m[2] || '';
      if (isNaN(this.target) || reduceMotion || !('IntersectionObserver' in window)) return;

      this.io = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          this.io.disconnect();
          this.run();
        }.bind(this),
        { threshold: 0.4 }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    format(n) {
      return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    run() {
      var self = this;
      var start = null;
      var duration = 1300;

      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        self.textContent = self.format(self.target * eased) + self.suffix;
        if (p < 1) self.raf = requestAnimationFrame(step);
      };
      this.raf = requestAnimationFrame(step);
    }
  }

  /* ------------------------------------------------------- Слайдер ------ */
  /* Scroll-snap лента; стрелките местят с ~80% от видимата ширина. */

  class HmSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      var btn = event.target.closest('[data-slide-dir]');
      if (!btn || !this.track) return;
      this.track.scrollBy({
        left: Number(btn.dataset.slideDir) * this.track.clientWidth * 0.8,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }
  }

  /* ------------------------------------------------- „Запази повода“ ---- */
  /* Имейл напомняне: customer формата записва абоната (съгласието е
     задължителен чекбокс в разметката), а тук само пълним скритото
     contact[tags] поле – съставния povod: таг и предизчисления
     povod-napomni:MM-DD ден, върху който стъпва автоматизацията в
     Omnisend/Flow. Без JS формата пак работи – само без датовите тагове. */

  class HmOccasion extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.onChange = this.syncTags.bind(this);
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('input', this.onChange);
      this.syncTags();
    }

    val(key) {
      var sel = { type: '[data-occ-type]', name: '[data-occ-name]', date: '[data-occ-date]' }[key];
      var el = this.querySelector(sel);
      return el ? el.value.trim() : '';
    }

    syncTags() {
      var tags = this.querySelector('[data-occ-tags]');
      if (!tags) return;

      var parts = ['povod-napomnyane'];
      var type = this.val('type');
      var date = this.val('date');
      var name = this.val('name');

      if (date) {
        // Съставен таг: един на повод, за да остане връзката дата↔име↔тип
        // и при няколко запазени повода от същия клиент.
        parts.push('povod:' + date.slice(5) + '|' + name + '|' + type);

        // Предварително изчислен ден за напомнянето (датата минус дните от
        // настройката). Така автоматизацията пита само „кой има таг с
        // днешна дата“ – без никаква датова аритметика в самия workflow.
        var alarmDays = parseInt(this.dataset.alarmDays, 10) || 7;
        var p = date.split('-').map(Number);
        var d = new Date(p[0], p[1] - 1, p[2]);
        d.setDate(d.getDate() - alarmDays);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        parts.push('povod-napomni:' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()));
      }

      tags.value = parts.join(', ');
    }
  }

  /* -------------------------------------------- Таймер „поръчай до…“ ---- */
  /* В петата на чекмеджето: пон–пет преди крайния час отброява до него
     („при теб още утре“, петък – събота с бележката за офис/автомат);
     извън прозореца показва деня на доставка (събота/неделя → „във
     вторник“). Смята по часа в България, не по часовника на посетителя.
     Текстовете идват от настройките на секцията през data-атрибути с
     плейсхолдъри {час}/{ден}/{таймер}. Чекмеджето се подменя от Section
     Rendering API – connectedCallback тръгва наново при всяко опресняване,
     disconnectedCallback чисти интервала на старата инстанция. */

  class HmCutoff extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('.drawer__cutoff-text');
      if (!this.textEl) return;
      this.hour = parseInt(this.dataset.hour, 10) || 15;
      this.state = '';
      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    bgNow() {
      try {
        return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Athens' }));
      } catch (e) {
        return new Date();
      }
    }

    esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    /* „в сряда“ / „във вторник“; събота носи бележката за офис/автомат. */
    dayLabel(dow) {
      var names = ['την Κυριακή', 'τη Δευτέρα', 'την Τρίτη', 'την Τετάρτη', 'την Πέμπτη', 'την Παρασκευή', 'το Σάββατο'];
      var label = names[dow];
      if (dow === 6 && this.dataset.satNote) label += ' (' + this.dataset.satNote + ')';
      return label;
    }

    render(template, day) {
      this.textEl.innerHTML = this.esc(template)
        .replace('{час}', this.hour)
        .replace('{ден}', '<b>' + this.esc(day) + '</b>')
        .replace('{таймер}', '<b class="drawer__cutoff-timer"></b>');
      this.timerEl = this.textEl.querySelector('.drawer__cutoff-timer');
    }

    tick() {
      var now = this.bgNow();
      var dow = now.getDay();

      if (dow >= 1 && dow <= 5 && now.getHours() < this.hour) {
        // Преди крайния час: доставката е утре (петък → събота).
        if (this.state !== 'count-' + dow) {
          this.state = 'count-' + dow;
          var day = 'αύριο κιόλας';
          if (dow === 5 && this.dataset.satNote) day += ' (' + this.dataset.satNote + ')';
          this.render(this.dataset.countText || '', day);
        }
        var deadline = new Date(now.getFullYear(), now.getMonth(), now.getDate(), this.hour, 0, 0);
        var left = Math.max(0, Math.floor((deadline - now) / 1000));
        var pad2 = function (n) { return String(n).padStart(2, '0'); };
        var mm = Math.floor(left % 3600 / 60);
        var text = left >= 3600
          ? Math.floor(left / 3600) + ':' + pad2(mm) + ':' + pad2(left % 60)
          : mm + ':' + pad2(left % 60);
        if (this.timerEl) this.timerEl.textContent = text;
        return;
      }

      // Извън прозореца: следващият работен ден обработва поръчката,
      // доставката е ден по-късно (петък обработва → събота пристига).
      var p = dow;
      do { p = (p + 1) % 7; } while (p === 0 || p === 6);
      var delivery = p === 5 ? 6 : p + 1;
      if (this.state !== 'later-' + delivery) {
        this.state = 'later-' + delivery;
        this.render(this.dataset.laterText || '', this.dayLabel(delivery));
      }
    }
  }

  /* -------------------------------------------------- Кошница-чекмедже -- */
  /* Add-to-cart формите се прихващат и минават през /cart/add.js; после
     чекмеджето се опреснява от Section Rendering API (?sections=cart-drawer),
     така че цени и суми винаги идват рендирани от сървъра. При мрежов срив
     формата се събмитва класически – /cart страницата остава като fallback. */

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  class HmCartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.drawer__panel');
      if (!this.panel) return;

      this.onDocClick = this.onDocClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onKey = this.onKey.bind(this);
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('submit', this.onSubmit);
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('submit', this.onSubmit);
      document.removeEventListener('keydown', this.onKey);
    }

    onDocClick(event) {
      var opener = event.target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        this.open();
        return;
      }

      var closer = event.target.closest('[data-drawer-close]');
      if (closer && this.contains(closer)) {
        this.close();
        return;
      }

      var qty = event.target.closest('[data-drawer-qty]');
      if (qty && this.contains(qty)) {
        this.change(qty.dataset.line, qty.dataset.drawerQty);
      }
    }

    onSubmit(event) {
      var form = event.target;
      var action = (form.getAttribute && form.getAttribute('action')) || '';
      if (action.indexOf('/cart/add') === -1) return;

      event.preventDefault();
      this.add(form);
    }

    onKey(event) {
      if (!this.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        this.close();
        return;
      }

      // Лек focus trap: Tab обикаля само в панела.
      if (event.key !== 'Tab') return;
      var focusables = this.panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    async add(form) {
      if (this.busy) return;
      this.setBusy(true);

      var res;
      try {
        res = await fetch(routesRoot() + 'cart/add.js', { method: 'POST', body: new FormData(form) });
      } catch (e) {
        // Мрежов срив – класическият submit води до /cart и си върши работата.
        this.setBusy(false);
        form.submit();
        return;
      }

      var errText;
      if (!res.ok) {
        var body = await res.json().catch(function () { return {}; });
        errText = body.description;
      }

      try { await this.refresh(); } catch (e) { /* показваме каквото има */ }
      this.open();
      if (!res.ok) this.showError(errText);
      this.setBusy(false);
    }

    async change(line, quantity) {
      if (this.busy) return;
      this.setBusy(true);

      try {
        await fetch(routesRoot() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
        });
        await this.refresh();
      } catch (e) {
        this.showError();
      }
      this.setBusy(false);
    }

    async refresh() {
      var res = await fetch(routesRoot() + '?sections=cart-drawer');
      var data = await res.json();
      var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');

      var fresh = doc.querySelector('.drawer__panel');
      if (fresh) this.panel.innerHTML = fresh.innerHTML;

      var count = doc.querySelector('[data-drawer-item-count]');
      if (count) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count.textContent.trim();
        });
      }

      // Опресняването сменя бутоните под фокуса – връщаме го на панела.
      if (this.classList.contains('is-open') && !this.panel.contains(document.activeElement)) {
        this.panel.focus();
      }
    }

    showError(message) {
      var box = this.querySelector('[data-drawer-error]');
      if (!box) return;
      box.textContent = message || this.dataset.errorText;
      box.hidden = false;
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.returnFocus = document.activeElement;
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.panel.focus();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.returnFocus && this.returnFocus.focus) this.returnFocus.focus();
    }

    setBusy(busy) {
      this.busy = busy;
      this.classList.toggle('is-busy', busy);
    }
  }

  /* Имейл-капчър popup. Веднъж на X дни (localStorage); формата се
     събмитва класически (customer form няма JSON API) – преди това се
     вдига sessionStorage флаг, така че след redirect-а с
     ?customer_posted=true popup-ът се отваря пак, но в успешното
     състояние с промо кода. */
  class HmPopup extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('.popup__card');
      if (!this.card) return;

      this.onClick = this.onClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKey);

      var form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', function () {
          try { sessionStorage.setItem('hm-popup-posted', '1'); } catch (e) { /* ok */ }
        });
      }

      var posted = window.location.search.indexOf('customer_posted=true') !== -1;
      var flagged = false;
      try { flagged = sessionStorage.getItem('hm-popup-posted') === '1'; } catch (e) { /* ok */ }

      if (posted && flagged) {
        try { sessionStorage.removeItem('hm-popup-posted'); } catch (e) { /* ok */ }
        this.showSuccess();
        this.open();
        return;
      }

      // Грешка във формата (redirect без customer_posted) – отваряме пак, за да се вижда.
      if (flagged && this.querySelector('.popup__err')) {
        try { sessionStorage.removeItem('hm-popup-posted'); } catch (e) { /* ok */ }
        this.open();
        return;
      }

      if (!this.due()) return;
      var delay = (Number(this.dataset.delay) || 9) * 1000;
      this.timer = setTimeout(this.open.bind(this), delay);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      if (this.timer) clearTimeout(this.timer);
    }

    due() {
      var days = Number(this.dataset.days) || 15;
      try {
        var at = Number(localStorage.getItem('hm-popup-at') || 0);
        return Date.now() - at > days * 86400000;
      } catch (e) {
        return true;
      }
    }

    remember() {
      try { localStorage.setItem('hm-popup-at', String(Date.now())); } catch (e) { /* ok */ }
    }

    showSuccess() {
      var ask = this.querySelector('[data-popup-ask]');
      var ok = this.querySelector('[data-popup-success]');
      if (ask) ask.hidden = true;
      if (ok) ok.hidden = false;
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(
        function () { this.classList.add('is-open'); }.bind(this)
      );
      this.remember();
      this.card.focus();
    }

    close() {
      this.classList.remove('is-open');
      this.hidden = true;
      this.remember();
    }

    onClick(event) {
      if (event.target.closest('[data-popup-close]')) this.close();
    }

    onKey(event) {
      if (event.key === 'Escape' && !this.hidden) this.close();
    }
  }

  customElements.define('hm-popup', HmPopup);
  customElements.define('hm-accordion', HmAccordion);
  customElements.define('hm-reveal', HmReveal);
  customElements.define('hm-count', HmCount);
  customElements.define('hm-slider', HmSlider);
  customElements.define('hm-sticky-buy', HmStickyBuy);
  customElements.define('hm-occasion', HmOccasion);
  customElements.define('hm-cart-drawer', HmCartDrawer);
  customElements.define('hm-cutoff', HmCutoff);
  customElements.define('hm-typewriter', HmTypewriter);
  customElements.define('hm-quantity', HmQuantity);
  customElements.define('hm-variants', HmVariants);
  customElements.define('hm-gallery', HmGallery);
  customElements.define('hm-menu', HmMenu);
})();
